import React from 'react';
import * as Unicons from '@oolio-group/react-native-unicons';
import { useTheme } from '../../hooks/useTheme';

const pascalCase = (s: string) =>
  s.replace(/(^\w|[-_\s]+\w)/g, m => m.replace(/[-_\s]/, '').toUpperCase());

interface Props {
  name: string;
  size?: number;
  color?: string;
}

const Icon: React.FC<Props> = ({ name, size = 20, color }) => {
  const { colors } = useTheme();
  const Component = Unicons['Uil' + pascalCase(name)];

  if (!Component) {
    return null;
  }
  return <Component size={size} color={color ?? colors.icon} />;
};

export default Icon;
